import type { SurveyQuestion } from "../../../types/survey.types";
import type { SurveyQuestionType } from "../../../data";
import { validateChoiceQuestion } from "./choice-question";
import { validateGridQuestion } from "./grid-question";

type QuestionValidator = (question: SurveyQuestion) => string | null;

const QUESTION_TYPE_VALIDATORS: Partial<Record<SurveyQuestionType, QuestionValidator>> = {
  multiple_choice: validateChoiceQuestion,
  multiple_answer: validateChoiceQuestion,
  dropdown: validateChoiceQuestion,
  multiple_choice_grid: validateGridQuestion,
  checkbox_grid: validateGridQuestion,
};

export const validateSurveyQuestion = (
  question: SurveyQuestion,
  index: number,
): string | null => {
  const questionNumber = question.position || index + 1;
  const questionText = question.data.question.trim();

  if (!questionText) {
    return `Please enter a question for question ${questionNumber}`;
  }

  const validator = QUESTION_TYPE_VALIDATORS[question.type];
  return validator?.(question) ?? null;
};

export const validateSurveyQuestions = (questions: SurveyQuestion[]): string | null => {
  for (let index = 0; index < questions.length; index += 1) {
    const validationMessage = validateSurveyQuestion(questions[index], index);

    if (validationMessage) {
      return validationMessage;
    }
  }

  return null;
};
